import * as React from 'react';
import { Tooltip } from '@cian/ui-kit';
import { Faq16 } from '@cian/ui-kit/prev';

import { RateTooltipContent } from '../RateTooltipContent';
import * as styles from './RateTooltip.css';

export interface IRateTooltipProps {
  description: string;
  title: string;
}

export const RateTooltip: React.VFC<IRateTooltipProps> = ({ title, description }) => {
  return (
    <Tooltip theme="white" placement="top-start" title={<RateTooltipContent title={title} description={description} />}>
      <span className={styles['icon']}>
        <Faq16 color="primary_100" />
      </span>
    </Tooltip>
  );
};
